import { jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Price from "../Price/Price.js";
import './CarCard.css';/* empty css             */
const CarCardPayment = ({ label, value, className, hidden }) => {
  if (hidden) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    Price,
    {
      title: label,
      value,
      valueColor: "dark-light",
      titleColor: "dark",
      className: classnames("perxis-auto-car-card-payment", className)
    }
  );
};
export {
  CarCardPayment as default
};
//# sourceMappingURL=CarCardPayment.js.map
